/**
 * Shared constants for adblock detection.
 * Used by both frontend detection and backend bait routes.
 */

// Bait script paths - commonly blocked by ad blockers
// All under /ads/ root for Cloudflare caching
export const BAIT_PATHS = ['/ads/banner.js', '/ads/advert/loader.js', '/ads/advertising/tracking.js'];

// Feature param key for rollout percentage (controlled via Redis)
export const ADBLOCK_MODAL_ROLLOUT_PARAM = 'adblock_modal_rollout_percent';

// Default rollout when param not set (0 = disabled)
export const ADBLOCK_MODAL_ROLLOUT_DEFAULT = 0;

// Hours until modal can show again after dismissal (24 hours = 1 day)
export const ADBLOCK_MODAL_MUTE_HOURS = 24;

// Milliseconds to wait after detection before showing the modal.
// Combined with ~2.5s detection time, the modal appears ~9.5s (desktop)
// or ~12.5s (mobile) after page load — the "sweet spot" for user compliance.
export const ADBLOCK_MODAL_DISPLAY_DELAY_MS = 7_000;
export const ADBLOCK_MODAL_DISPLAY_DELAY_MOBILE_MS = 10_000;
